import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../data/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { KadyChainConversation, KadyChainConversationListHolder, KadyChainDailyConversations, sortConversationsByDate, sortDailyConversationsByDate } from '../data/kadychain';
import moment from 'moment';

@Component({
  selector: 'app-kadychain-conversations-viewer',
  templateUrl: './kadychain-conversations-viewer.component.html',
  styleUrl: './kadychain-conversations-viewer.component.css'
})
export class KadychainConversationsViewerComponent implements OnInit {
  @Input() studentID: number;
  kadyChainConversationGuid: string = "d4f790d8-7d4f-4bee-b85f-c60cf1553c24";
  kadyChainDailyConversations: KadyChainDailyConversations[]
  selectedConversation: KadyChainConversation
  selectedDailyConversations: KadyChainDailyConversations
  conversationGuidListHolder: KadyChainConversationListHolder
  conversationsLoaded: boolean = false
  constructor(
    protected sanitizer: DomSanitizer,
    protected dataService: DataService
  ) {

  }
  ngOnInit() {
    this.kadyChainDailyConversations = new Array();
    this.dataService.getKadyChainGuidHolder(this.studentID, this.kadyChainConversationGuid, null).subscribe(artifacts => {
      if (artifacts && artifacts.shortSummaryGuidHolders) {
        console.log('Original artifacts:', artifacts.shortSummaryGuidHolders);
        
        // Filter out empty guids and all-zero guids
        const validHolders = artifacts.shortSummaryGuidHolders.filter(holder => {
          const isValid = holder && 
                         holder.guid && 
                         typeof holder.guid === 'string' && 
                         holder.guid.trim().length > 0 &&
                         !(/^[0\-]+$/.test(holder.guid));
          if (!isValid) {
            console.log('Filtering out invalid holder:', holder);
          }
          return isValid;
        });

        console.log('Filtered artifacts:', validHolders);
        
        this.conversationGuidListHolder = artifacts;
        this.conversationGuidListHolder.shortSummaryGuidHolders = validHolders;
        
        if (validHolders.length === 0) {
          console.log('No valid conversations found');
          this.conversationsLoaded = true;
          return;
        }

        var totalartifacts = validHolders.length;
        var loadedArtifacts = 0;
        validHolders.forEach(element => {
          this.dataService.getKadyChainConversationArtifact(this.studentID, element.guid, null).subscribe(
            artifact => {
              loadedArtifacts++;
              if (artifact) {
                console.log('Valid artifact fetched:', artifact);
                this.groupConversationsByDate(artifact);
              } else {
                console.log('Skipping null artifact for guid:', element.guid);
              }
              
              if (totalartifacts === loadedArtifacts) {
                console.log('Final conversations:', this.kadyChainDailyConversations);
                this.conversationsLoaded = true;
              }
            },
            error => {
              console.error('Error fetching artifact:', error);
              loadedArtifacts++;
              if (totalartifacts === loadedArtifacts) {
                this.conversationsLoaded = true;
              }
            }
          );
        });
      } else {
        console.log('No artifacts or invalid artifact structure received');
        this.conversationsLoaded = true;
      }
    });
  }
  groupConversationsByDate(convo: KadyChainConversation) {
    var indexOfDate = this.findDateIndex(this.kadyChainDailyConversations, convo.CreationTimeUtc);
    if (this.kadyChainDailyConversations.length == 0 || indexOfDate == -1) {
      var newKadyChainConversationArray = new Array();
      newKadyChainConversationArray.push(convo);
      var newDailyKadyChainConversation = new KadyChainDailyConversations
      newDailyKadyChainConversation.Conversations = newKadyChainConversationArray;
      newDailyKadyChainConversation.Date = convo.CreationTimeUtc
      this.kadyChainDailyConversations.push(newDailyKadyChainConversation)
      sortDailyConversationsByDate(this.kadyChainDailyConversations);
    } else {
      this.kadyChainDailyConversations[indexOfDate].Conversations.push(convo);
      sortConversationsByDate(this.kadyChainDailyConversations[indexOfDate].Conversations);
    }
  }
  findDateIndex(conversations: KadyChainDailyConversations[], targetDate: Date): number {
    var convertedTargetDate = moment(targetDate)
    return conversations.findIndex(conversation => {
      var convertedConversationDate = moment(conversation.Date)
      return convertedConversationDate.year() === convertedTargetDate.year() &&
        convertedConversationDate.month() === convertedTargetDate.month() &&
        convertedConversationDate.day() === convertedTargetDate.day();
    });
  }
  SummaryReturner(value: any): string {
    return value ?? 'There is no Summary For this Conversation';
  }
  DateReturner(convos: KadyChainDailyConversations): string {
    return moment(convos.Date).format('MM/DD/YYYY');
  }
  ShortSummaryReturner(convos: KadyChainConversation): string {
    return  convos.shortSummarizedConversation ?? 'No short summary';
  }

  handleConversationSelection(convo: KadyChainConversation): void {
    this.selectedConversation = convo
  }
  handleConversationsDateSelection(convos: KadyChainDailyConversations): void {
    this.selectedDailyConversations = convos
  }



}
